export const BAD_COLOR = '#FF9999';
export const GOOD_COLOR = '#A1E3CB';
export const BLUE_COLOR = '#145DD7';
export const BLACK_COLOR = '#000';
export const NETFLOW_BAD_COLOR = '#DC6803';
export const NETFLOW_GOOD_COLOR = '#0057FF';
export const BACKGROUND_LIGHT_BLUE_COLOR = '#F3F8FF';
export const BORDER_LIGHT_BLUE_COLOR = '#C9DEFF';
export const BORDER_LIGHT_GREEN_COLOR = '#ABEFC6';
export const BACKGROUND_LIGHT_GREEN_COLOR = '#ECFDF3';
export const BACKGROUND_LIGHT_RED_COLOR = '#FEF3F2';
export const BORDER_LIGHT_RED_COLOR = '#FECDCA';
export const BORDER_LIGHT_WARNING_COLOR = '#FEDF89';
export const BACKGROUND_LIGHT_WARNING_COLOR = '#FFFAEB';

export const CHIP_GREEN = ['#ECFDF3', '#ABEFC6', '#0C714F'];
export const CHIP_RED = ['#FEF3F2', '#FECDCA', '#B42318'];
export const CHIP_YELLOW = ['#FFFAEB', '#FEDF89', '#B54708'];
export const CHIP_BLUE = ['#F3F8FF', '#C9DEFF', '#175CD3'];
